// @flow

import { getConfiguratorSettings } from './main';

import type { State } from '../reducers';

type GlobalState = {
  configuratorSettings: State,
};

type Packages = $PropertyType<State, 'packages'>;

type UspFeaturesLabel = $PropertyType<Packages, 'usp_features_label'>;
export const getUspFeaturesLabel = (state: GlobalState): UspFeaturesLabel => (
  getConfiguratorSettings(state).packages.usp_features_label
);

type CompareCollapsedButtonText = $PropertyType<Packages, 'compare_collapsed_button_text'>;
export const getCompareCollapsedButtonText = (state: GlobalState): CompareCollapsedButtonText => (
  getConfiguratorSettings(state).packages.compare_collapsed_button_text
);

type CompareExpandedButtonText = $PropertyType<Packages, 'compare_expanded_button_text'>;
export const getCompareExpandedButtonText = (state: GlobalState): CompareExpandedButtonText => (
  getConfiguratorSettings(state).packages.compare_expanded_button_text
);

export default null;
